import { S4DPage } from './s4dIssueMessages';
import { S4DToppingRef } from './s4dProductComparison';

const s4dPagePaths: Record<S4DPage, string> = {
  [S4DPage.Product]: 'Content/Secure/Menu/Products/AddEdit.aspx',
  [S4DPage.Prices]: 'Content/Secure/Menu/Products/Prices.aspx',
};

const s4dToppingPath = 'Content/Secure/Menu/Toppings/AddEdit.aspx';

export const getS4DProductHref = (s4dAdminBaseUrl: string, s4dId: number, page: S4DPage): string =>
  `${s4dAdminBaseUrl}/${s4dPagePaths[page]}?product=${s4dId}`;

export const getS4DToppingHref = (s4dAdminBaseUrl: string, topping: S4DToppingRef): string =>
  `${s4dAdminBaseUrl}/${s4dToppingPath}?topping=${topping.s4dId}&return=details`;
